<template>
    <div class="mx-auto container container--fluid">

        <v-snackbar v-model="snackbar" top :color="color" timeout="6000">
            {{ snackbar_msg }}
            <v-btn text dark @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box pa-4">
            <h3 class="section-title mb-3">Clearance Request</h3>
            <v-row dense class="mt-2 mb-2" align="center">
                <v-col cols="auto">
                    <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile">
                        <v-icon left color="success">mdi-export</v-icon>
                        Export
                    </v-btn>
                </v-col>
                <v-spacer></v-spacer>

                <v-col cols="auto">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" hide-details outlined
                        style="width: 500px" dense />
                </v-col>
                <v-spacer></v-spacer>

                <v-col cols="auto">
                    <v-btn class="primary" @click="openAddRequest" :disabled="request_data.length > 0 && !isAllRejected">
                        Add Request
                    </v-btn>
                </v-col>
            </v-row>

            <v-card class="mb-6 pa-4 mt-4 request-table">
                <h3 class="section-title mb-3">Clearance Request Summary</h3>
                <v-simple-table dense class="bordered-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Request Date</th>
                            <th>Reason</th>
                            <th>Last Working Date</th>
                            <th>Status</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, index) in request_data" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ formatDate(item.request_date) }}</td>
                            <td>{{ item.reason }}</td>
                            <td>{{ formatDate(item.date) }}</td>
                            <td>

                                <v-chip small :color=" item.clearance_status === 'Approved'? 'green': 
                                                       item.clearance_status === 'Rejected'? 'red': 'orange'" dark>
                                    {{ item.clearance_status || 'In-Process' }}
                                </v-chip>
                            </td>
                        </tr>

                        <tr v-if="!request_data.length">
                            <td colspan="5" class="text-center text-grey">
                                No request found
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>

                <v-row justify="center">
                    <v-btn class="mt-4" color="error" outlined v-if="request_data.length > 0" @click="deleteRequest(request_data[request_data.length-1].id)"
                        :disabled="request_data[request_data.length-1].clearance_status === 'Approved'">
                        Cancel
                    </v-btn>
                </v-row>
            </v-card>


            <v-data-table :headers="headers" :items="clearance_dept_data" dense class="elevation-1 mytable center-header"
                :search="search" :item-key="'id'" >

                <template v-slot:top>
                    <v-toolbar flat dense>
                        <h3 class="section-title mb-3">Clearance Flow</h3>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                </template>

                <template v-slot:item.srno="{ item }">
                    {{ clearance_dept_data.indexOf(item) + 1 }}
                </template>

                <template v-slot:item.is_last_approving="{ item }">
                    <v-icon :color="item.is_last_approving ? 'green' : 'red'">
                        {{ item.is_last_approving ? 'mdi-check-circle' : 'mdi-close-circle' }}
                    </v-icon>
                </template>

                <template #item.action_date="{ item }">
                    <span>
                        {{ item.action_date ? formatDate(item.action_date) : "-" }}
                    </span>
                </template>

                <template v-slot:item.responsible_person="{ item }">
                    <div class="d-flex align-center justify-center">
                        <span v-if="item.showInstructorName">
                            {{ item.responsible_person }}
                        </span>
                        <v-icon small class="ml-1 cursor-pointer" v-if="item.showInstructorName"
                            @click="hideInstructorName(item)">
                            mdi-close
                        </v-icon>

                        <v-icon :color="item.responsible_person ? 'blue' : 'grey'" class="cursor-pointer" v-else
                            @click="revealInstructorName(item)">
                            mdi-eye
                        </v-icon>
                    </div>
                </template>

                <template v-slot:item.remark="{ item }">
                    <v-icon color="blue" style="cursor: pointer" v-if="item.remark"
                        @click="selectedRemark = item.remark; dialog_remark = true">
                        mdi-eye
                    </v-icon>
                    <span v-else>-</span>
                </template>

            </v-data-table>
            <v-dialog v-model="dialog_remark" max-width="400">
                <v-card>
                    <v-card-title>Remark</v-card-title>
                    <v-card-text>
                        {{ selectedRemark }}
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" @click="dialog_remark = false">OK</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="transaction_dialog" max-width="500px">
                <v-card>
                    <v-form v-model="valid">

                        <v-card-title class="toolbar">
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-col cols="12" class="pt-0">
                            <v-icon color="error" small>*</v-icon>
                            <v-autocomplete label="Select Clerance Status" v-model="selected_status"
                                :items="status_list" item-text="name" item-value="id" outlined dense required
                                hide-details />
                        </v-col>

                        <v-col cols="12">
                            <v-icon color="error" small>*</v-icon>
                            <v-textarea label="Enter Remark" v-model="remark" rows="3" outlined />
                        </v-col>

                        <v-card-actions class="justify-center pt-0">
                            <v-btn color="gray" @click="close">Cancel</v-btn>
                            <v-btn color="primary" @click="saveTransaction">Save</v-btn>
                        </v-card-actions>

                    </v-form>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialog" max-width="500px">
                <v-card>
                    <v-form v-model="valid">

                        <v-card-title class="toolbar">
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-col cols="12">
                            <v-icon color="error" size="small">*</v-icon>
                            <v-textarea label="Enter Reason" v-model="reason" rows="3" outlined />
                        </v-col>

                        <v-row justify="center" class="ma-0">
                            <v-icon color="error" class="pb-10 mr-2" size="small">*</v-icon>

                            <v-col cols="12" sm="6" class="d-flex justify-center pa-0">
                                <v-menu v-model="menu" :close-on-content-click="false" transition="scale-transition">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-bind="attrs" v-on="on" v-model="date"
                                            label="Last Date In Institute" readonly outlined append-icon="mdi-calendar"
                                            dense />
                                    </template>

                                    <v-date-picker v-model="date" @input="menu = false" />
                                </v-menu>
                            </v-col>
                        </v-row>

                        <v-card-actions class="justify-center pt-0">
                            <v-btn color="gray" @click="close">Cancel</v-btn>
                            <v-btn color="primary" @click="saveRequest">Save</v-btn>
                        </v-card-actions>

                    </v-form>
                </v-card>
            </v-dialog>
        </v-card>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </div>
</template>
<script>
import axios from "axios";
import * as XLSX from "xlsx";

export default {
    data: () => ({
        overlay: false,
        snackbar: false,
        snackbar_msg: "",
        color: "",
        search: "",
        dialog: false,
        dialog_remark: false,
        selectedRemark: "",
        menu: false,
        valid: true,
        formTitle: "Add Clearance Request",
        reason: "",
        date: null,
        hasFetched: false,
        transaction_dialog: false,
        transaction_item: null,
        loader:false,
        isAllRejected:"",

        selected_user_type: "",
        selected_instructor: "",
        selected_status: "",
        remark: "",
        clearance_dept_data: [],
        filtered_request_data: [],
        request_data: [],

        headers: [
            { text: "S.No", value: "srno", class: "text-center" },
            { text: "User Type", value: "usertype",class: "text-center" },
            { text: "Department", value: "dept_name", align: "center", class: "text-center" },
            { text: "Responsible Person", value: "responsible_person", align: "center", class: "text-center" },
            { text: "Level", value: "level", align: "center", class: "text-center" },
            { text: "Is Last Approving", value: "is_last_approving", align: "center", class: "text-center" },
            { text: "Action By", value: "action_by", align: "center", class: "text-center" },
            { text: "Action Date", value: "action_date", align: "center", class: "text-center" },
            { text: "Clearance Status", value: "clearance_status", align: "center", class: "text-center" },
            { text: "Remark", value: "remark", align: "center", class: "text-center" },
        ],
        editedIndex: -1,
        editedItem: {
            id: "",
            new_user_type: "",
            selected_dept_type: "",
            selected_user: "",
            isactive: true,
        },
    }),
    watch: {
        dialog(val) {
            val || this.close();
        },
        
    },

    mounted() {
        this.getClearanceData();
        this.getRequestData();
        this.getStatus();
        this.getUsers();
    },

    methods: {
        downloadFile() {
            this.loader = true;
            const excelData = this.clearance_dept_data.map((item, index) => ({
                "User Type": item.usertype,
                "Clearance Department": item.dept_name,
                "Responsible Person": item.responsible_person ? item.responsible_person : "Not Assigned",
                "level": item.level,
                "Is Last Approving" : item.is_last_approving=="true" ? "Yes" : "No",
                "Action By" : item.action_by ? item.action_by : "-",
                "Action Date" : item.action_date ? item.action_date: "-",
                "Clearance Status": item.clearance_status,
                "Remark": item.remark ? item.remark : "-"

            }));

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Clearance Request");
            XLSX.writeFile(workbook, "ClearanceRequest.xlsx");

            this.loader = false;
        },
        showSnackbar(color, msg) {
            this.color = color;
            this.snackbar_msg = msg;
            this.snackbar = true;
        },
        openAddRequest() {
            this.reason = "";
            this.date = null;
            this.menu = false;
            this.dialog = true;
        },
        close() {
            this.dialog = false;
            this.transaction_dialog = false;
            this.menu = false;
        },
        openTransactionDialog(item) {
            this.transaction_item = item;
            this.transaction_dialog = true;
            this.selected_instructor = "";
            this.selected_status = "";
            this.remark = "";
        },

        revealInstructorName(item) {
            if (item.responsible_person) {
                this.$set(item, 'showInstructorName', true);
            }
        },

        hideInstructorName(item) {
            this.$set(item, 'showInstructorName', false);
        },

        editItem(item) {
            this.editedIndex = -1;
            this.dialog = true;
        },

        //check all requests are rejected or not
        isAllRejectedRequests(){
           this.isAllRejected = this.request_data.every(item => 
                item.clearance_status == "Rejected"             
            )
              console.log("=================="+this.isAllRejected);
        },

        getClearanceData() {
            this.overlay = true;
            axios.post("/Dues/getClearanceData")
                .then(res => {
                    this.overlay = false;
                    if (res.data.msg === "200") {
                         this.getRequestData();
                        this.clearance_dept_data = res.data.clearance_dept_data;
                    }
                });     
        },

        getRequestData() {
            this.overlay = true;
            axios.post("/Dues/getRequestData")
                .then(res => {
                    this.overlay = false;
                    if (res.data.msg === "200") {
                        this.request_data = res.data.clearance_request_data;
                        this.isAllRejectedRequests();
                    }
                });
        },

        saveRequest() {
            if(this.reason && this.date){
                const payload = {
                    reason: this.reason,
                    date: this.date
                };
                axios.post("/Dues/saveRequest", payload)
                    .then(res => {
                        if (res.data.code === "SUCCESS") {
                            this.showSnackbar("#4caf50", "Request Added Successfully");
                            this.getRequestData();
                            this.getClearanceData();
                        } else if (res.data.code === "NA") {
                            this.showSnackbar("#b71c1c", "Request Already Present!!!");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong");
                        }
                    })
                    .finally(() => {
                        this.close();
                    });
            }else{
                this.showSnackbar("#b71c1c", "Fill all mandatory fields");
            }  
        },

        deleteRequest(id) {
            if(confirm("Are you sure want to cancel the request")){
            const payload = {
                id: id
            };
            axios.post("/Dues/deleteRequest", payload)
                .then(res => {
                    if (res.data.code === "SUCCESS") {
                        this.showSnackbar("#4caf50", "Request Deleted Successfully");
                        this.getRequestData();
                        this.getClearanceData();
                    } else if (res.data.code === "NA") {
                        this.showSnackbar("#b71c1c", "Request Not Present!!!");
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong");
                    }
                })
                .finally(() => {
                    this.close();
                });
            }
        },

        formatDate(dateStr) {
            if (!dateStr) return "";
            const d = new Date(dateStr);
            const year = d.getUTCFullYear();
            const month = String(d.getUTCMonth() + 1).padStart(2, "0");
            const day = String(d.getUTCDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },
    },
};
</script>

<style scoped>
.section-title {
    font-weight: 600;
    color: #3f51b5;
}

.bordered-table th,
.bordered-table td {
    border: 1px solid #d0d0d0;
    padding: 8px;
    text-align: center;
    vertical-align: middle;
}

.request-table {
    margin: 0 auto;
    max-width: 900px;
}

.mytable /deep/ thead th {
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
    color: white !important;
    text-align: center;
}

.mytable ::v-deep tbody tr {
    min-height: 64px;
    /* row height */
    background-color: #f9f9f9;
    /* optional */
}

.mytable ::v-deep tbody td {
    padding-top: 16px;
    padding-bottom: 16px;
    align-items: center;
    /* vertical center content */
}

.bordered-table th{
    background: rgb(229, 124, 35);
    color: white !important;
}


</style>
